import { render, staticRenderFns } from "./NCS.vue?vue&type=template&id=5d2fdcbe&"
import script from "./NCS.vue?vue&type=script&lang=js&"
export * from "./NCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports